import type { ArchiveRequest } from './mockDataArchive'

export interface ArchiveRegisterEntry {
  id: string
  jobId: string
  jobNumber: string
  jobDescription: string
  filename: string
  generatedAt: string
  requestType: string
  requestLabel: string
  profileLabel: string | null
  outputs: string[]
  archiveReadyPct: number | null
  sourceRequestId: string | null
  archiveRequestSnapshot: ArchiveRequest | null
  counts: {
    purchaseOrders: number
    variations: number
    progressClaims: number
    permits: number
    inspections: number
    swms: number
    siteDiaries: number
    incidents: number
    ncrs: number
  }
}

const STORAGE_KEY = 'tp_archive_register'

function canUseStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
}

export function getArchiveRegister(): ArchiveRegisterEntry[] {
  if (!canUseStorage()) return []
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as ArchiveRegisterEntry[]
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function saveArchiveRegister(entries: ArchiveRegisterEntry[]) {
  if (!canUseStorage()) return
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
}

export function appendArchiveRegisterEntry(entry: ArchiveRegisterEntry) {
  const next = [entry, ...getArchiveRegister()].slice(0, 200)
  saveArchiveRegister(next)
}

export function removeArchiveRegisterEntry(entryId: string) {
  saveArchiveRegister(getArchiveRegister().filter((entry) => entry.id !== entryId))
}

export function clearArchiveRegister() {
  saveArchiveRegister([])
}
